export const environment = {
  production: true,
  api: 'https://takidapp.com:8008/',
  hub: 'https://takidapp.com:8008/SecuritySupervisorHub',
  appLink: '#/auth/login',


        //json file
        langJson: 'https://translate-more-systems-production.up.railway.app/api/json/Takid_security',
        // langJson: 'http://localhost:3000/api/json/Takid_security',

  };
